module.exports = __webpack_public_path__ + "485b4620ec2e21b31c158690d85546d7.pdf";